module.exports = __webpack_public_path__ + "img/invatatura-ecaterinei-a-ii-a-1773-pagina-de-titlu-big.93c086f6.png";